import { Component, OnInit } from '@angular/core';
import { ICON_TYPE } from "../../../icons/icon.model";

@Component({
  selector: 'app-custom-logo',
  templateUrl: './custom-logo.component.html',
  styleUrls: ['./custom-logo.component.scss'],
  standalone: false
})
export class CustomLogoComponent implements OnInit {

  iconTypes = ICON_TYPE;

  constructor() {
  }

  ngOnInit(): void {
  }

}
